<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="receipt-traffic-example-dialog ah-detail-dialog"
        top="5vh"
        width="950px"
        append-to-body
        @open="onOpen"
        @close="onClose()"
    >
        <template slot="title">
            <div>車票單據範例</div>
        </template>
        <div class="two-sides-layout">
            <div>
                <el-menu :default-active="activeMenuIndex" class="el-menu-vertical-demo" @select="handleSelect">
                    <el-menu-item index="1">高鐵車票</el-menu-item>
                    <el-menu-item index="3">台鐵車票</el-menu-item>
                </el-menu>
            </div>
            <div ref="example-scroll-view">
                <template v-if="activeMenuIndex === '1'">
                    <div class="example-list">
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-1.jpg"
                                    style="width: 80%; border-radius: 15px; box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-2.jpg"
                                    style="width: 80%; border-radius: 15px; box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-app.jpg"
                                    style="width: 80%; border-radius: 15px; box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-3.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-7-11.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-family.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-ok.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanHighSpeedRail-doc.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="activeMenuIndex === '3'">
                    <div class="example-list">
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanRailway-1.jpg"
                                    style="width: 45%; box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="example-item">
                            <div class="example-image">
                                <img
                                    src="@/assets/img/receipt-traffic-example/taiwanRailway-doc.jpg"
                                    style="box-shadow: 3px 5px 20px rgba(0,0,0,0.12);"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeMenuIndex: '1',
        };
    },
    methods: {
        handleSelect(index) {
            this.activeMenuIndex = index;
            this.$refs['example-scroll-view'].scrollTop = 0;
        },
        onOpen() {

        },
        onClose() {
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss">
.receipt-traffic-example-dialog.ah-detail-dialog {
    .el-dialog {
        overflow: hidden;
    }

    .two-sides-layout {
        display: grid;
        grid-template-columns: 150px auto;
        height: 550px;

        >:nth-child(2) {
            background-color: #f2f2f2;
            padding: 80px 0 120px 0;
            height: 100%;
            overflow-y: auto;
        }
    }
    .example-list {
        display: grid;
        grid-template-columns: auto;
        gap: 85px;
        position: relative;
        width: 75%;
        margin: 0 auto;

        >.example-item {
            >.example-title {
                text-align: center;
                color: #463cb2;
                font-weight: bold;
                font-size: 11pt;
                margin-top: 15px;
                display: none;
            }
            >.example-image {
                img {
                    display: block;
                    width: 100%;
                    margin: 0 auto;
                }
            }

        }
    }
}
</style>
